// extracted by mini-css-extract-plugin
export default {"input":"Input_input__k5Ctk","iconStart":"Input_iconStart__J6e3c","left":"Input_left__tznb8","center":"Input_center__gBEel","right":"Input_right__7JUYb"};